'use client'

import { FormEvent, useContext, useEffect, useState } from "react";
import api from "@/util/api";
import customAlert from "@/util/customAlert";
import dynamic from "next/dynamic";
import { editPageTypes, editTypes } from "@/type/edit";
import React from "react";
import { top_game_sports_list } from "@/type/sports";
import { CommunityListContext } from "@/app/community/_config";
import { useTranslations } from "next-intl";

const CustomEditor = dynamic(() => import('@/components/board/editor'), { ssr: false, loading: ()=> <div>loading...</div> });

interface EditProps {
    post: string
    editContent?: any
    setSelectContent: Function
    setEditView: Function
    fetchData?: (id?:number) => void
    editPage: editPageTypes
}

export default function EditView({
    post,
    editContent,
    setSelectContent,
    setEditView,
    fetchData
}: EditProps) {
    const { editCategory, setContent } = useContext(CommunityListContext)
    const [content, setEditContent] = useState<string>('')
    const [editId, setEditId] = useState<number>()
    const [editTitle, setEditTitle] = useState<string>('')
    const [editType, setEditType] = useState<editTypes>('insert')

    const t = useTranslations("Text")    
    const a = useTranslations("Sentence")    

    async function EditSubmitHandlr(e: FormEvent<HTMLFormElement>) {
        e.preventDefault();

        const formData = new FormData(e.currentTarget)

        // 검증
        if (!formData.get('title')) {
            customAlert(a('InvalidTitle'), 'warning')
            return;
        }
        if (!formData.get('content')) {
            customAlert(a('InvalidContent'), 'warning')
            return;
        }

        api(post + "edit/", { method: "POST", body: formData })
            .then(res => res.json())
            .then(async ({ status_code, status, message, data }) => {
                customAlert(message, status)
                if (status_code == 200) {
                    
                    const newId = Number(data.object.id);
                    console.log("****", newId)

                    setEditView(false)

                    
                    setSelectContent(newId);
                    fetchData?.(newId);
                    
                    // if (typeof fetchData === 'function') {}fetchData();
                    

                }else{
                    customAlert(message, 'error')
                }
            })
            .catch((error: Response) => {
                console.error(error)
                customAlert(a("ErrorRequest"), 'error')
            })
    }

    useEffect(() => {
        if (editContent) {
            setEditType('update')
            setEditContent(editContent.content)
            setEditId(editContent.id)
            setEditTitle(editContent.title)
        } else {
            setEditType('insert')
            setEditContent('')
            setEditId(undefined)
            setEditTitle('')
        }
        

        if(!post){
            customAlert(`${t("ErrorRequest")} (post : ${post})`, 'error')
            setEditView(false)
        }
    }, [editContent, post])

    

    return (
        <div className="board-edit-container" >
            <form onSubmit={EditSubmitHandlr}>
                <input type="hidden" name="type" value={editType} />
                <input type="hidden" name="cate" value={editCategory} />
                <input type="hidden" name="id"   value={editId} />

                <input type="hidden" name="content" value={content} />
                <input type="text" name="title" value={editTitle} placeholder={t("제목입력")}
                    onChange={e => setEditTitle(e.currentTarget.value)} />
                <CustomEditor onChange={data => setEditContent(data)} initialData={content} />
                <div className="btns">
                    <button type="submit">{t("등록")}</button>
                    <button type="button" onClick={e => setEditView(false)}>{t("취소")}</button>
                </div>
            </form>
        </div>
    )
}

